import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Component for displaying textColor svg icon
 * @param props -SvgIconProps
 * @returns textColor svg icon
 * @example -<CcfTextColorIcon>
 */
export function CcfTextColorIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="FormatColorTextIcon">
      <path d="M0 15C0 14.4477 0.447715 14 1 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15Z" fill="#333333" />
      <path d="M11.3781 12L10.2609 8.82812H5.89374L4.77655 12H2.79999L7.04999 0.53125H9.12811L13.3703 12H11.3781ZM9.77655 7.21875L8.69061 4.09375C8.64895 3.95833 8.58905 3.76823 8.51093 3.52344C8.4328 3.27344 8.35468 3.02083 8.27655 2.76562C8.19843 2.50521 8.13332 2.28646 8.08124 2.10938C8.02915 2.32292 7.96405 2.5625 7.88593 2.82812C7.81301 3.08854 7.74009 3.33333 7.66718 3.5625C7.59947 3.79167 7.54738 3.96875 7.51093 4.09375L6.41718 7.21875H9.77655Z" fill="#333333" />
    </SvgIcon>
  );
}

export default CcfTextColorIcon;
